import { State } from "./Compare.types";

export const DEFAULT_COMPARER_STATE: State = {
  envs: {},
  envsData: {
    isLoading: false,
    error: "",
    firstEnvData: null,
    secondEnvData: null,
  },
  compareData: {
    firstEnvData: null,
    secondEnvData: null,
  },
  pickedEnvs: {
    firstEnv: "",
    secondEnv: "",
  },
  filterItems: [],
  compareKey: "",
  isComparing: false,
};

export enum ACTION_KEYS {
  SET_ENVS = "SET_ENVS",
  SET_ENVS_DATA_START_FETCH = "SET_ENVS_DATA_START_FETCH",
  SET_ENVS_DATA_FETCH_ERROR = "SET_ENVS_DATA_FETCH_ERROR",
  SET_ENVS_DATA_FETCH_SUCCESS = "SET_ENVS_DATA_FETCH_SUCCESS",
  SET_COMPARE_DATA = "SET_COMPARE_DATA",
  SET_COMPARE_KEY = "SET_COMPARE_KEY",
  SET_FIRST_PICKED_ENV = "SET_FIRST_PICKED_ENV",
  SET_SECOND_PICKED_ENV = "SET_SECOND_PICKED_ENV",
}

type Actions =
  | { type: ACTION_KEYS.SET_ENVS; payload: Record<string, unknown> }
  | { type: ACTION_KEYS.SET_ENVS_DATA_START_FETCH }
  | { type: ACTION_KEYS.SET_ENVS_DATA_FETCH_ERROR }
  | {
      type: ACTION_KEYS.SET_ENVS_DATA_FETCH_SUCCESS;
      payload: {
        filterItems: {
          value: string;
          label: string;
        }[];
        firstEnvData: unknown;
        secondEnvData: unknown;
        firstEnvCompareData: unknown;
        secondEnvCompareData: unknown;
      };
    }
  | {
      type: ACTION_KEYS.SET_COMPARE_DATA;
      payload: { firstEnvData: unknown; secondEnvData: unknown };
    }
  | { type: ACTION_KEYS.SET_COMPARE_KEY; payload: string }
  | { type: ACTION_KEYS.SET_FIRST_PICKED_ENV; payload: string }
  | { type: ACTION_KEYS.SET_SECOND_PICKED_ENV; payload: string };

export const compareReducer = (state: State, action: Actions) => {
  switch (action.type) {
    case ACTION_KEYS.SET_ENVS: {
      return { ...state, envs: action.payload };
    }

    case ACTION_KEYS.SET_ENVS_DATA_START_FETCH: {
      return {
        ...state,
        envsData: {
          ...state.envsData,
          isLoading: true,
          error: "",
        },
      };
    }

    case ACTION_KEYS.SET_ENVS_DATA_FETCH_ERROR: {
      return {
        ...state,
        envsData: {
          ...state.envsData,
          isLoading: false,
          error: "Error occurred during fetching enviroment settings",
        },
      };
    }

    case ACTION_KEYS.SET_ENVS_DATA_FETCH_SUCCESS: {
      return {
        ...state,
        filterItems: action.payload.filterItems,
        isComparing: true,
        envsData: {
          ...state.envsData,
          isLoading: false,
          firstEnvData: action.payload.firstEnvData,
          secondEnvData: action.payload.secondEnvData,
        },
        compareData: {
          firstEnvData: action.payload.firstEnvCompareData,
          secondEnvData: action.payload.secondEnvCompareData,
        },
      };
    }

    case ACTION_KEYS.SET_COMPARE_DATA: {
      return {
        ...state,
        compareData: {
          firstEnvData: action.payload.firstEnvData,
          secondEnvData: action.payload.secondEnvData,
        },
      };
    }

    case ACTION_KEYS.SET_COMPARE_KEY: {
      return { ...state, compareKey: action.payload, isComparing: false };
    }

    case ACTION_KEYS.SET_FIRST_PICKED_ENV: {
      return {
        ...state,
        isComparing: false,
        pickedEnvs: { ...state.pickedEnvs, firstEnv: action.payload },
      };
    }

    case ACTION_KEYS.SET_SECOND_PICKED_ENV: {
      return {
        ...state,
        isComparing: false,
        pickedEnvs: { ...state.pickedEnvs, secondEnv: action.payload },
      };
    }

    default:
      throw new Error("Such action is not supported");
  }
};
